export const keys = {
  ctrlKey: false,
  altKey: false,
  shiftKey: false,
  metaKey: false,
}

document.addEventListener("keydown", (e) => {
  for (var key in keys) {
    if (keys.hasOwnProperty(key)) {
      keys[key] = e[key]
    }
  }
})

document.addEventListener("keyup", (e) => {
  for (var key in keys) {
    if (keys.hasOwnProperty(key)) {
      keys[key] = e[key]
    }
  }
})



// WEBPACK FOOTER //
// ./src/lib/keys.ts